<div class="legal-note-frame">

    <div class="legal-notice" id="legalNotice">
        <div class="close">
            <button (click)="close()">
                <img src="assets/icons/x-mark-48.png" alt="close">
            </button>
        </div>

        <div class="text" [innerHTML]="legalNotice">

        </div>

    </div>
</div>